module.exports = {"420504001":"点军街道","420504101":"艾家镇","420504102":"桥边镇","420504201":"联棚乡","420504202":"土城乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420504.json
// module id = 1727
// module chunks = 0